import { attachmentResponseSchema, type Attachment, type UploadKind } from '@chatapp-inbox/shared';
import { API_BASE, uploadFile } from './http';

export interface UploadAttachmentParams {
  conversationId: string;
  file: File;
  /** Tipo já decidido (o que o navegador informou, ou o da extensão do nome). */
  mimeType: string;
  signal?: AbortSignal;
  /** De 0 a 1, enquanto o arquivo sobe. */
  onProgress?: (fraction: number) => void;
  /** Nota de voz gravada no navegador: o servidor a converte e o WhatsApp a mostra como mensagem de voz. */
  voice?: boolean;
}

/**
 * Sobe o arquivo para a conversa (ainda não é uma mensagem): devolve o anexo `uploaded`, que o
 * `sendMessage` cita pelo id. O servidor confere tipo, tamanho e o conteúdo de verdade.
 */
export async function uploadAttachment(params: UploadAttachmentParams): Promise<Attachment> {
  const { attachment } = await uploadFile(
    `/conversations/${encodeURIComponent(params.conversationId)}/attachments`,
    {
      query: { name: params.file.name, ...(params.voice ? { voice: '1' } : {}) },
      file: params.file,
      contentType: params.mimeType,
      schema: attachmentResponseSchema,
      ...(params.signal ? { signal: params.signal } : {}),
      ...(params.onProgress ? { onProgress: params.onProgress } : {}),
    },
  );
  return attachment;
}

/**
 * Endereço do arquivo de um anexo (mesma origem: o navegador manda o cookie de sessão). `download`
 * força o "salvar como", mesmo para o que abriria na página.
 */
export function attachmentContentUrl(attachmentId: string, o: { download?: boolean } = {}): string {
  return `${API_BASE}/attachments/${encodeURIComponent(attachmentId)}/content${
    o.download ? '?download=1' : ''
  }`;
}

export type { UploadKind };
